import _ from 'lodash'

import { tourDetails, trains } from '../../api/api'
import { isRailBookers } from '../../configuration/brand'
import { addAccommodationsToTripItinerary, getAllTourAccommodations } from '../../utilities/content/tours'

export const FETCH_TOUR_DETAILS_BEGIN   = 'FETCH_TOUR_DETAILS_BEGIN'
export const FETCH_TOUR_DETAILS_SUCCESS = 'FETCH_TOUR_DETAILS_SUCCESS'
export const FETCH_TOUR_DETAILS_ERROR = 'FETCH_TOUR_DETAILS_ERROR'
export const FETCH_TRAINS_SUCCESS = 'FETCH_TRAINS_SUCCESS'

export const fetchTrains = () => (dispatch, getState) => {
  const brand = _.get(getState(), 'configurationData.data.brand')
  return trains(brand)
    .then(response => {
      const tour = _.get(getState(), 'tourDetailsData.data')
      const tourTrains = _.filter(_.map(_.get(tour, 'relatedTrains'), train => {
        return Boolean(response[train.id]) ? { ...train, ...response[train.id] } : null
      }))
      dispatch({ type: FETCH_TRAINS_SUCCESS, payload: tourTrains })
    })
}

export const fetchTourDetails = () => (dispatch, getState) => {
  dispatch({ type: FETCH_TOUR_DETAILS_BEGIN })
  const brand = _.get(getState(), 'configurationData.data.brand')
  const tourId = _.get(getState(), 'configurationData.data.tourId')

  return tourDetails(brand, tourId)
    .then(response => {
      const tour = _.get(response, 'tour')
      const tripItineraryWithAccommodations = addAccommodationsToTripItinerary(
        _.get(response, 'accommodations'),
        tour,
      )

      const shouldGroupAccommodations = tour.isGetaway
        || tour.softripBooking
        || tour.tripItineraryIsEmpty

      let tourDetails = {
        ...tour,

        availability: _.get(response, 'availability'),
  
        ...(shouldGroupAccommodations && {
          tourAccommodations: getAllTourAccommodations(tripItineraryWithAccommodations)
        }),
  
        tripItinerary: tripItineraryWithAccommodations,
      }

      if (isRailBookers()) {
        dispatch(fetchTrains())
      }
      dispatch({type: FETCH_TOUR_DETAILS_SUCCESS, payload: tourDetails})
    })
    .catch(error => dispatch({
      type: FETCH_TOUR_DETAILS_ERROR,
      payload: 'There was an error retrieving the tour details - please wait a moment, then try again.',
    }))
}
